'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _htmlToReact = require('html-to-react');

var _htmlToReact2 = _interopRequireDefault(_htmlToReact);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _button = require('../../../atoms/button');

var _button2 = _interopRequireDefault(_button);

var _heading = require('../../../atoms/heading');

var _heading2 = _interopRequireDefault(_heading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var htmlToReactParser = new _htmlToReact2.default.Parser();

var ORGANISM_NAME = 'steps';

var SimpleSteps = function (_React$Component) {
  _inherits(SimpleSteps, _React$Component);

  function SimpleSteps() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SimpleSteps);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SimpleSteps.__proto__ || Object.getPrototypeOf(SimpleSteps)).call.apply(_ref, [this].concat(args))), _this), _this.renderHeadline = function (headline) {
      if (headline && headline.text) {
        return _react2.default.createElement(
          _heading2.default,
          { level: '2', className: ORGANISM_NAME + '__headline' },
          htmlToReactParser.parse(headline.text)
        );
      }
      return null;
    }, _this.renderParagraph = function (paragraph) {
      if (paragraph && paragraph.text) {
        return _react2.default.createElement(
          'p',
          { className: ORGANISM_NAME + '__paragraph' },
          htmlToReactParser.parse(paragraph.text)
        );
      }
      return null;
    }, _this.renderHatchText = function (hatchText) {
      if (hatchText && hatchText.text) {
        return _react2.default.createElement(
          'p',
          { className: ORGANISM_NAME + '__hatch-text' },
          htmlToReactParser.parse(hatchText.text)
        );
      }
      return null;
    }, _this.renderStepsImage = function (idx, image) {
      var _this$props$config = _this.props.config,
          showImages = _this$props$config.showImages,
          showArrows = _this$props$config.showArrows;

      var renderArrows = function renderArrows() {
        if (showArrows && idx) {
          return _react2.default.createElement('span', { className: ORGANISM_NAME + '__arrow' });
        }
        return null;
      };

      if (image && image.src && showImages) {
        return _react2.default.createElement(
          'div',
          { className: ORGANISM_NAME + '__image-wrapper' },
          renderArrows(idx),
          _react2.default.createElement('img', { alt: '', src: image.src })
        );
      }
      return null;
    }, _this.renderSteps = function (steps) {
      if (steps) {
        return steps.map(function (elem, idx) {
          var key = '' + elem.step.text + idx;
          return _react2.default.createElement(
            'div',
            {
              key: key,
              className: 'col-md-4 col-sm-12 ' + ORGANISM_NAME + '__step ' + ORGANISM_NAME + '__step-' + idx
            },
            _this.renderStepsImage(idx, elem.image),
            _react2.default.createElement(
              'span',
              { className: ORGANISM_NAME + '__circle' },
              idx + 1
            ),
            _react2.default.createElement(
              'p',
              { className: ORGANISM_NAME + '__text pp-sans-small-regular' },
              htmlToReactParser.parse(elem.step.text)
            )
          );
        });
      }
      return null;
    }, _this.renderPrimaryCta = function (primaryCta) {
      if (primaryCta && primaryCta.text) {
        var buttonClass = ORGANISM_NAME + '__btn  pypl-btn--blue';
        var targetValue = primaryCta.target || '_self';
        return _react2.default.createElement(
          'div',
          { className: 'row steps__cta-container' },
          _react2.default.createElement(
            _button2.default,
            {
              href: primaryCta.href,
              id: primaryCta.id,
              className: buttonClass,
              fpti: 'StepsSmple-PrmryCTA-' + primaryCta.text,
              target: targetValue
            },
            primaryCta.text
          )
        );
      }
      return null;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SimpleSteps, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          content = _props.content,
          config = _props.config,
          className = _props.className;
      var headline = content.headline,
          paragraph = content.paragraph,
          hatchText = content.hatchText,
          steps = content.steps,
          primaryCta = content.primaryCta;


      var stepsClasses = (0, _classnames2.default)(ORGANISM_NAME, config.theme, className);

      return _react2.default.createElement(
        'section',
        {
          className: stepsClasses,
          id: config.id ? config.id : null,
          'data-building-block': 'organism'
        },
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'col-md-10 center-block text-xs-center' },
              this.renderHeadline(headline)
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'col-md-10 center-block text-xs-center' },
              this.renderParagraph(paragraph)
            )
          ),
          headline && headline.text || paragraph && paragraph.text ? _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'col-md-12' },
              _react2.default.createElement('hr', null)
            )
          ) : null,
          _react2.default.createElement(
            'div',
            { className: ORGANISM_NAME + '__container row' },
            this.renderSteps(steps)
          ),
          this.renderPrimaryCta(primaryCta),
          this.renderHatchText(hatchText)
        )
      );
    }
  }]);

  return SimpleSteps;
}(_react2.default.Component);

exports.default = SimpleSteps;


SimpleSteps.propTypes = {
  config: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    theme: _propTypes2.default.oneOf(['theme-background-color-white', 'theme-background-color-light']).isRequired,
    showImages: _propTypes2.default.bool,
    showArrows: _propTypes2.default.bool
  }),
  content: _propTypes2.default.shape({
    headline: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }),
    paragraph: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }),
    hatchText: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }),
    primaryCta: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired,
      href: _propTypes2.default.string.isRequired,
      id: _propTypes2.default.string,
      target: _propTypes2.default.oneOf(['_self', '_blank'])
    }),
    steps: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      image: _propTypes2.default.shape({
        src: _propTypes2.default.string.isRequired
      }),
      step: _propTypes2.default.shape({
        text: _propTypes2.default.string.isRequired
      }).isRequired
    })).isRequired
  }),
  className: _propTypes2.default.string
};

SimpleSteps.defaultProps = {
  config: {
    id: '',
    theme: 'theme-background-color-white',
    showImages: true,
    showArrows: true
  },
  content: {
    headline: {
      text: '34 characters maximum'
    },
    paragraph: {
      text: '152 characters maximum per paragraph to not equal more than 5 lines of copy on ' + 'mobile devices.'
    },
    steps: [{
      image: {
        src: 'https://www.paypalobjects.com/digitalassets/c/website/marketing/global/kui/organisms/steps-accordion/step1.png'
      },
      step: {
        text: '45 characters maximum per step'
      }
    }, {
      image: {
        src: 'https://www.paypalobjects.com/digitalassets/c/website/marketing/global/kui/organisms/steps-accordion/step2.png'
      },
      step: {
        text: '45 characters maximum per step'
      }
    }, {
      image: {
        src: 'https://www.paypalobjects.com/digitalassets/c/website/marketing/global/kui/organisms/steps-accordion/step3.png'
      },
      step: {
        text: '45 characters maximum per step'
      }
    }],
    hatchText: {
      text: '34 characters maximum per line'
    },
    primaryCta: {
      text: '29 characters maximum',
      href: '#',
      id: '',
      target: '_self'
    }
  },
  className: ''
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/simple-steps/jsx/SimpleSteps.js
// module id = 1142
// module chunks = 4